import axios from "axios";
import store from "@/store";
import router from "@/router";

const api = (version = "v2") => {
  const v2 = axios.create({
    baseURL: `${process.env.VUE_APP_API_URL}/api/${version}`,
    headers: {
      "X-AUTH-TOKEN": store.getters.token,
      "Authorization": `Bearer ${store.getters.expressToken}`
    }
  });

  v2.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      const status = error.response.status;
      if (status === 401) {
        router.push("/logout");
      }

      return Promise.reject(error);
    }
  );

  return v2;
};

export default api;